module.exports = __webpack_public_path__ + "static/media/noun_click_927323_000000 copy 2.53066e30.svg";